import * as FormsApiService from '../Common/Services/FormsApiService';
import actionTypes from './formSummary.actionTypes'
import FormatQuestions from './questionCharts/questionChartsFormatter'
import { addErrorMessage  } from '../Common/Components/flashMessage/flashMessage.actions';

export const getSummaryData = (companyId, employeeId, formInstanceId, includeParticipants, viewConfidentially) => {
  return async (dispatch, getState) => {
    dispatch({ type: actionTypes.FETCH_SUMMARY_QUESTIONS_BEGIN, payload: { companyId, employeeId } });

    try {
      let response = {};

      response = await FormsApiService.getFormInstanceWithConfidentiality(companyId, employeeId, formInstanceId, includeParticipants, viewConfidentially);

      if (response) {
        let summaryData = FormatQuestions(response);
        dispatch({ type: actionTypes.FETCH_SUMMARY_QUESTIONS_SUCCESS, data: summaryData });
      }
      else {
        dispatch({ type: actionTypes.FETCH_SUMMARY_QUESTIONS_FAILURE });
        dispatch(addErrorMessage('Error retrieving summary.', 'Error'));
      }
    }
    catch (e) {
        dispatch({ type: actionTypes.FETCH_SUMMARY_QUESTIONS_FAILURE });
        dispatch(addErrorMessage('Error retrieving summary.', 'Error'));
      }
  }
};

